// extracted by mini-css-extract-plugin
export default {"content":"style_content__0LiMs","search":"style_search__JPWZN"};